<!--
 * @Author: ningbo.kang
 * @Date: 2019-12-14 18:23:36
 * @LastEditors: ningbo.kang
 * @LastEditTime: 2020-04-07 13:14:45
 * @Description: 描述
 -->
<template>
  <div class="wg-card">
    <a-card :title="widget.name"
      :size="options.size"
      :type="options.type"
      v-if="!options.hidden"
      :bordered="false">
      <a-tabs>
        <template v-for="(panel,index) in widget.tabs">
          <a-tab-pane :tab="panel.label"
            :key="index">
            <!-- 循环输出其中的列表 -->
            <wgList :list="panel.list"></wgList>
          </a-tab-pane>
        </template>
      </a-tabs>
    </a-card>
  </div>
</template>
<script>
import baseMixin from '../lib/baseMixin';

export default {
  name: 'wgTabs',
  mixins: [baseMixin],
  data() {
    return {
      options: {
        size: 'small',
        type: 'line',
        customClass: '',
        hidden: false,
        remoteFunc: '',
        remoteOption: '',
      },
    };
  },
};
</script>
